export const Theme = {
    light: {
        primary: '#7D3CE8',
        primaryText: '#FFFFFF',
        secondary: '#7ACDD4',
        secondaryText: '#212121',
        title: '#212121',
        background: '#FFFFFF',
        scroll: '#C4C4C4',
        skeleton: ['#eee','#f5f5f5'],

        palette: {
            darkPurple: '#9226C0',
            lightPurple: '#DD8AFF',
            pink: '#EC3EA2',
            blue: '#5739EA',
            yellow: '#F2C94C',
            lightGreen: '#30CF5D',
            coral: '#F26457',
            orange: '#FF8500',
            lightBlue: '#4DBCAC',
            purple: '#7D3CE8',
            cyan: '#7ACCD3',
            danger: '#ED856F',
            lightCoral: '#F49577',
            green: '#4CAF50',
            gray: '#E0E0E0'
        },

        palette2: [
            '#9226C0',
            '#DD8AFF',
            '#EC3EA2',
            '#5739EA',
            '#F2C94C',
            '#30CF5D',
            '#F26457',
            '#FF8500',
            '#4DBCAC',
            '#7D3CE8',
            '#7ACCD3',
            '#AD3EDB',
            '#ED856F',
            '#F49577',
            '#4CAF50',
            '#E0E0E0'
        ],

        // Status
        online: '#6FCF97',
        pause: '#F2C94C',
        offline: '#ED856F',
        idle: '#989898',
        error: '#D94848',

        navbar: {
            background: '#7D3CE8',
            text: '#FFFFFF',
            fontWeight: 'normal',
            active: {
                background: '#8C54E8',
                text: '#FFFFFF',
                fontWeight: 'normal',
            },
            hover: {
                background: '#8C54E8',
                text: '#FFFFFF'
            }
        },

        container: {
            primary: {
                background: '#FFFFFF',
                boxShadow: '-2px 5px 20px rgba(0, 0, 0, 0.05)',
                text: '#212121',
                title: '#212121',
                border: 'none',
                borderRadius: '5px'
            },
            secondary: {
                background: '#FFFFFF',
                boxShadow: '-2px 5px 20px rgba(0, 0, 0, 0.05)',
                text: '#686868',
                title: '#4F4F4F',
                border: 'none',
                borderRadius: '5px'
            }
        },

        // Button
        button: {
            primary: {
                background: '#7D3CE8',
                boxShadow: 'none',
                border: '1px solid #7D3CE8',
                borderRadius: '3px',
                text: '#FFFFFF',
                fontSize: '14px',
                outline: 'none',
                transition: 'background 250ms',

                hover: {
                    background: '#6C2BD7',
                    text: '#FFFFFF',
                },

                disabled: {

                }
            },
            secondary: {
                background: '#FFFFFF',
                boxShadow: 'none',
                border: '1px solid #E0E0E0',
                borderRadius: '3px',
                text: '#989898',
                fontSize: '14px',
                outline: 'none',
                transition: 'background 250ms',

                hover: {
                    background: '#DDDDDD',
                    text: '#989898',
                },

                disabled: {

                }
            }
        },

        // Input
        input: {
            background: '#FFFFFF',
            border: '1px solid #E0E0E0',
            text: '#989898',
            borderRadius: '3px',

            focus: {
                boxShadow: '0px 0px 5px 0px #DDDDDD'
            }
        }
    },
    dark: {
        primary: '#9A5CFF',
        primaryText: '#000000',
        secondary: '#5ADBDB',
        secondaryText: '#000000',
        title: '#FFFFFF',
        background: '#212121',
        scroll: '#CACACA',
        skeleton: ['#CACACA', '#212121'],

        palette: {
            darkPurple: '#9226C0',
            lightPurple: '#DD8AFF',
            pink: '#EC3EA2',
            blue: '#5739EA',
            yellow: '#F2C94C',
            lightGreen: '#30CF5D',
            coral: '#F26457',
            orange: '#FF8500',
            lightBlue: '#4DBCAC',
            purple: '#7D3CE8',
            cyan: '#7ACCD3',
            danger: '#ED856F',
            lightCoral: '#F49577',
            green: '#4CAF50',
            gray: '#E0E0E0'
        },

        palette2: [
            '#9226C0',
            '#DD8AFF',
            '#EC3EA2',
            '#5739EA',
            '#F2C94C',
            '#30CF5D',
            '#F26457',
            '#FF8500',
            '#4DBCAC',
            '#7D3CE8',
            '#7ACCD3',
            '#AD3EDB',
            '#ED856F',
            '#F49577',
            '#4CAF50',
            '#E0E0E0'
        ],

        // Status
        online: '#6FCF97',
        pause: '#FF9800',
        offline: '#F44336',
        idle: '#989898',
        error: '#F44336',

        navbar: {
            background: '#333333',
            text: '#F5F5F5',
            fontWeight: 'normal',
            active: {
                background: '#515151',
                text: '#F5F5F5',
                fontWeight: 'normal',
            },
            hover: {
                background: '#3C3C3C',
                text: '#F5F5F5'
            }
        },

        container: {
            primary: {
                background: '#3A3A3A',
                boxShadow: '-2px 5px 20px rgba(0, 0, 0, 0.05)',
                text: '#D2D2DA',
                title: '#FAFAFA',
                border: 'none',
                borderRadius: '3px'
            },
            secondary: {
                background: '#5A5A5A',
                boxShadow: 'none',
                text: '#D2D2DA',
                title: '#FFFFFF',
                border: 'none',
                borderRadius: '3px'
            }
        },

        // Button
        button: {
            primary: {
                background: '#9A5CFF',
                boxShadow: 'none',
                border: '1px solid #9A5CFF',
                borderRadius: '3px',
                text: '#fff',
                fontSize: '14px',
                outline: 'none',
                transition: 'background 250ms',

                hover: {
                    background: '#733CCB',
                    text: '#fff',
                },

                disabled: {
                    background: '#5A5A5A',
                }
            },
            secondary: {
                background: '#212121',
                boxShadow: 'none',
                border: '1px solid #D2D2DA',
                borderRadius: '3px',
                text: '#FAFAFA',
                fontSize: '14px',
                outline: 'none',
                transition: 'background 250ms',

                hover: {
                    background: '#313131',
                    text: '#FAFAFA',
                },

                disabled: {
                    background: '#212121',
                    border: '1px solid #616161'
                }
            }
        },

        // Input
        input: {
            background: '#393939',
            border: '1px solid #212121',
            text: '#C4C4C4',
            borderRadius: '3px',

            hover: {
                boxShadow: '0px 0px 5px rgba(97, 97, 97, 0.3)'
            },

            focus: {
                boxShadow: 'box-shadow: 0px 0px 5px rgba(97, 97, 97, 0.5)',
                border: '1px solid #C4C4C4'
            }
        }
    },
    orkut: {
        primary: '#5898CE',
        primaryText: '#FFFFFF',
        secondary: '#E95B95',
        secondaryText: '#FFFFFF',
        title: '#000000',
        background: '#D9E6F7',
        scroll: '#5898CE',
        skeleton: ['#5898CE', '#D9E6F7'],

        palette: {
            darkPurple: '#9226C0',
            lightPurple: '#DD8AFF',
            pink: '#EC3EA2',
            blue: '#5739EA',
            yellow: '#F2C94C',
            lightGreen: '#30CF5D',
            coral: '#F26457',
            orange: '#FF8500',
            lightBlue: '#4DBCAC',
            purple: '#7D3CE8',
            cyan: '#7ACCD3',
            danger: '#ED856F',
            lightCoral: '#F49577',
            green: '#4CAF50',
            gray: '#E0E0E0'
        },

        palette2: [
            '#9226C0',
            '#DD8AFF',
            '#EC3EA2',
            '#5739EA',
            '#F2C94C',
            '#30CF5D',
            '#F26457',
            '#FF8500',
            '#4DBCAC',
            '#7D3CE8',
            '#7ACCD3',
            '#AD3EDB',
            '#ED856F',
            '#F49577',
            '#4CAF50',
            '#E0E0E0'
        ],

        // Status
        online: '#6FCF97',
        pause: '#F2C94C',
        offline: '#ED856F',
        idle: '#989898',
        error: '#F44336',

        navbar: {
            background: '#5898CE',
            text: '#FFFFFF',
            fontWeight: 'normal',
            active: {
                background: '#6CA6D8',
                text: '#FFFFFF',
                fontWeight: 'normal',
            },
            hover: {
                background: '#6CA6D8',
                text: '#FFFFFF'
            }
        },

        container: {
            primary: {
                background: '#FFFFFF',
                boxShadow: 'none',
                text: '#333333',
                title: '#000000',
                border: 'none',
                borderRadius: '0'
            },
            secondary: {
                background: '#E8EEFA',
                boxShadow: 'none',
                text: '#333333',
                title: '#000000',
                border: 'none',
                borderRadius: '0'
            }
        },

        // Button
        button: {
            primary: {
                background: '#5898CE',
                boxShadow: 'none',
                border: '1px solid #5898CE',
                borderRadius: '3px',
                text: '#FFFFFF',
                fontSize: '14px',
                outline: 'none',
                transition: 'background 250ms',

                hover: {
                    background: '#588db9',
                    text: '#FFFFFF'
                },

                disabled: {

                }
            },
            secondary: {
                background: '#EFEFEF',
                boxShadow: 'none',
                border: '1px solid #767676',
                borderRadius: '3px',
                text: '#767676',
                fontSize: '14px',
                outline: 'none',
                transition: 'background 250ms',

                hover: {
                    background: '#BBBBBB',
                    text: '#767676',
                },

                disabled: {

                }
            }
        },

        // Input
        input: {
            background: '#EFEFEF',
            border: '1px solid #767676',
            text: '#767676',
            borderRadius: '3px',

            focus: {
                boxShadow: '0px 0px 5px 0px #ABABAB'
            }
        }
    },
    highContrast: {
        primary: '#ff0',
        primaryText: '#000',
        secondary: '#fff',
        secondaryText: '#000000',
        title: '#FFFFFF',
        background: '#000',
        scroll: '#FFF',
        skeleton: ['#eee', '#000'],

        palette: {
            darkPurple: '#9226C0',
            lightPurple: '#DD8AFF',
            pink: '#EC3EA2',
            blue: '#5739EA',
            yellow: '#F2C94C',
            lightGreen: '#30CF5D',
            coral: '#F26457',
            orange: '#FF8500',
            lightBlue: '#4DBCAC',
            purple: '#7D3CE8',
            cyan: '#7ACCD3',
            danger: '#ED856F',
            lightCoral: '#F49577',
            green: '#4CAF50',
            gray: '#E0E0E0'
        },

        palette2: [
            '#9226C0',
            '#DD8AFF',
            '#EC3EA2',
            '#5739EA',
            '#F2C94C',
            '#30CF5D',
            '#F26457',
            '#FF8500',
            '#4DBCAC',
            '#7D3CE8',
            '#7ACCD3',
            '#AD3EDB',
            '#ED856F',
            '#F49577',
            '#4CAF50',
            '#E0E0E0'
        ],

        // Status
        online: '#4caf50',
        pause: '#ff9800',
        offline: '#F34646',
        idle: '#989898',
        error: '#F34646',

        navbar: {
            background: '#000',
            text: '#FFF',
            fontWeight: 'bold',
            active: {
                background: '#FFF',
                text: '#000',
                fontWeight: 'bold'
            },
            hover: {
                background: '#fafafa',
                text: '#000'
            },
        },

        container: {
            primary: {
                background: '#000',
                boxShadow: '-2px 5px 20px rgba(0, 0, 0, 0.05)',
                text: '#FFF',
                title: '#FF0',
                border: '1px solid #FF0',
                borderRadius: '3px'
            },
            secondary: {
                background: '#FFF',
                boxShadow: 'none',
                text: '#000',
                title: '#0FF',
                border: '1px solid #FF0',
                borderRadius: '3px'
            }
        },

        // Button
        button: {
            primary: {
                background: '#FF0',
                boxShadow: 'none',
                border: '1px solid #FF0',
                borderRadius: '3px',
                text: '#000',
                fontSize: '14px',
                outline: 'none',
                transition: 'background 250ms',

                hover: {
                    background: '#DD0',
                    text: '#000'
                },

                disabled: {

                }
            },
            secondary: {
                background: '#000',
                boxShadow: 'none',
                border: '1px solid #0FF',
                borderRadius: '3px',
                text: '#0FF',
                fontSize: '14px',
                outline: 'none',
                transition: 'background 250ms',

                hover: {
                    background: '#0CC',
                    text: '#FFF'
                },

                disabled: {

                }
            }
        },

        // Input
        input: {
            background: '#000',
            border: '1px solid #0FF',
            text: '#0FF',
            borderRadius: '3px',

            hover: {
                boxShadow: 'none'
            },

            focus: {
                boxShadow: 'none',
                border: '#FF0'
            }
        }
    },
}